import { throttle } from 'lodash'
import { useRouter } from 'next/router'
import { useMemo, useState } from 'react'
import { AppHeaderSearch as Component } from 'ui-components'
import { getSearchResultsQuery } from 'utils'

import { SIZE } from '~header/constants/search'
import { useLazySearchMapsQuery } from '~header/services/search'

const Search = (props) => {
  const { onOpen } = props
  const router = useRouter()
  const page = router.query?.page || 1

  const [trigger, { results }] = useLazySearchMapsQuery({
    selectFromResult: (state) => ({
      results: state.data?.searchMaps?.items
    })
  })

  const [value, setValue] = useState(() => {
    const initialValue = router.query?.keywords || ''
    trigger({ query: initialValue, from: (page - 1) * SIZE, size: SIZE })
    return initialValue
  })

  const gotoSearchResults = () => {
    if (!value) return
    router.push({
      pathname: '/search-results',
      query: getSearchResultsQuery({ keywords: value })
    })
  }

  // Use debounce to throttle the lazyQuery function
  const debouncedTrigger = useMemo(() => throttle(trigger, 200), [trigger])

  const handleChange = (event, value) => {
    setValue(value)
    debouncedTrigger({ query: value, from: (page - 1) * SIZE, size: SIZE })
  }

  const handleSearchClick = () => {
    gotoSearchResults()
  }

  const handleSubmit = () => {
    gotoSearchResults()
  }

  return (
    <Component
      onOpen={onOpen}
      value={value}
      results={results}
      onChange={handleChange}
      onSearchClick={handleSearchClick}
      onSubmit={handleSubmit}
    />
  )
}

export { Search }
